import React from "react";
import DA_SearchInputB2bStyle from "../SearchInputB2bStyle/SearchInputB2bStyle.component";
import S from "./MiniSearchB2bStyle.module.scss";

export const DA_MiniSearchB2bStyle = () => (
    <div className={S.wrapper}>
        <DA_SearchInputB2bStyle trapFocus autoFocus />
    </div>
);
